import type { StanzaType } from "../lib/stanzaParser"

const FLUSH_INTERVAL_MS = 10_000

type MonitorStanzaType =
  | StanzaType
  | "unknown"
  | "error"
  | "account_config_pubsub_event"
  | "search_result"

type StanzaCounts = Partial<Record<MonitorStanzaType, number>>

const createStanzaVolumeMonitor = () => {
  let counts: StanzaCounts = {}
  let lastFlush = Date.now()

  const record = (type: MonitorStanzaType) => {
    counts[type] = (counts[type] || 0) + 1

    const now = Date.now()
    if (now - lastFlush >= FLUSH_INTERVAL_MS) {
      flush(now)
    }
  }

  const flush = (now: number) => {
    if (Object.keys(counts).length === 0) {
      lastFlush = now
      return
    }

    const total = Object.values(counts).reduce(
      (sum, count) => sum + (count || 0),
      0,
    )
    const elapsed = (now - lastFlush) / 1000
    const rate = Math.round((total / elapsed) * 10) / 10

    window.performance.mark("xmpp.stanza.volume", {
      detail: { ...counts, total, rate },
    })

    counts = {}
    lastFlush = now
  }

  return { record }
}

const stanzaVolumeMonitor = createStanzaVolumeMonitor()

export default stanzaVolumeMonitor
